import type { CSSProperties } from 'react';

const impactWords = ['BOOM!', 'KAPOW!', 'WHAM!'];

export function FightImpactOverlay({ fight, explosion }: { fight: boolean; explosion: boolean }) {
  return (
    <div className={`fight-impact${fight ? ' is-visible' : ''}${explosion ? ' is-exploding' : ''}`} aria-hidden="true">
      <strong>FIGHT!</strong>
      <div className="fight-impact__rays">{Array.from({ length: 12 }, (_, index) => <i key={index} style={{ '--impact-ray': index } as CSSProperties} />)}</div>
      <div className="fight-impact__words">
        {impactWords.map((word, index) => <b key={word} style={{ '--impact-word': index } as CSSProperties}>{word}</b>)}
      </div>
    </div>
  );
}
